import { useSelector, shallowEqual } from 'react-redux'


const all = { showPersonal: true, showCommon: true }
const personal = { showPersonal: true, showCommon: false }
const common = { showPersonal: false, showCommon: true }

export function useSubsidyType() {
  const subsidyType = useSelector((state: any) => state.reports.subsidies.params.subsidyType, shallowEqual)
  if (subsidyType === 'common') return common
  if (subsidyType === 'personal') return personal
  return all
}
